import {useEffect, useState} from 'react';

import QRCode from 'qrcode';

export const useQRCodeDataUrl = (qrCodeValue: string | null) => {
  const [QRCodeDataUrl, setQRCodeDataUrl] = useState<string | null>(null);

  useEffect(() => {
    async function generateQrCodeDataUrl(val: string) {
      setQRCodeDataUrl(await QRCode.toDataURL(val));
    }

    if (qrCodeValue) {
      generateQrCodeDataUrl(qrCodeValue);
    }
  }, [qrCodeValue]);

  return QRCodeDataUrl;
};
